<template>
  <div v-if="showTradeinOpportunities">
    <div class="mb-24 flex items-center justify-between">
      <div class="heading-2 flex items-center gap-8">
        <IconSwap />
        {{ i18n(translations.tradeinOpportunities) }}
      </div>

      <div class="flex items-center gap-24">
        <RevButton
          size="small"
          :to="{ name: ROUTE_NAMES.BUYBACK.OPPORTUNITIES }"
          variant="secondary"
        >
          {{ i18n(translations.viewDetails) }}
        </RevButton>
      </div>
    </div>

    <div>
      <RevLoadingScreen
        v-if="isLoadingOpportunities"
        class="mt-32"
        :text="i18n(translations.loading)"
      />

      <div v-if="!isLoadingOpportunities" class="space-y-12">
        <div class="border-static-default-mid rounded-sm w-full border p-24">
          <RevTag
            :label="
              i18n(translations.tradeinOpportunitiesTag, {
                total: String(totalOpportunities),
              })
            "
            size="large"
            variant="info"
          />
          <p>
            {{ i18n(translations.tradeinOpportunitiesDescription) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { RevTag } from '@ds/components/Tag'
import { IconSwap } from '@ds/icons/IconSwap'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSourcingOpportunitiesTotal } from '~/scopes/buyback/composables/useSourcingOpportunitiesTotal'

import translations from './TradeinOpportunitiesCard.translations'

const i18n = useI18n()

const { totalOpportunities, isLoading: isLoadingOpportunities } =
  useSourcingOpportunitiesTotal()

const showTradeinOpportunities = computed(
  () => isLoadingOpportunities.value || totalOpportunities.value > 0,
)
</script>
